import {AfterViewInit, Component, OnInit, ViewChild, Input} from '@angular/core';

@Component({
    selector: 'app-frt-billoflading-shipment-information',
    templateUrl: './frt-billoflading-shipment-information.component.html',
    styleUrls: ['./frt-billoflading-shipment-information.component.css'],
    standalone: false
})
export class FRTBillofladingShipmentInformationComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }
}
